import { ReactNode } from 'react';

export enum OneStringColor {
	lead = 'lead',
	supporting = 'supporting',
	inverse = 'inverse',
}

export enum OneStringTextStyle {
	displayXL = 'displayXL',
	displayLarge = 'displayLarge',
	header2XL = 'header2XL',
	headerXL = 'headerXL',
	headerLarge = 'headerLarge',
	headerMedium = 'headerMedium',
	headerSmall = 'headerSmall',
	headerXS = 'headerXS',
	header2XS = 'header2XS',
	bodyXLStandard = 'bodyXLStandard',
	bodyXLEmphasize = 'bodyXLEmphasize',
	bodyXLLink = 'bodyXLLink',
	bodyLargeStandard = 'bodyLargeStandard',
	bodyLargeEmphasize = 'bodyLargeEmphasize',
	bodyLargeLink = 'bodyLargeLink',
	bodyMediumStandard = 'bodyMediumStandard',
	bodyMediumEmphasize = 'bodyMediumEmphasize',
	bodyMediumLink = 'bodyMediumLink',
	bodySmallStandard = 'bodySmallStandard',
	bodySmallEmphasize = 'bodySmallEmphasize',
	bodySmallLink = 'bodySmallLink',
	labelXLStandard = 'labelXLStandard',
	labelXLEmphasize = 'labelXLEmphasize',
	labelLargeStandard = 'labelLargeStandard',
	labelLargeEmphasize = 'labelLargeEmphasize',
	labelMediumStandard = 'labelMediumStandard',
	labelMediumEmphasize = 'labelMediumEmphasize',
	labelSmallStandard = 'labelSmallStandard',
	labelSmallEmphasize = 'labelSmallEmphasize',
	labelXSStandard = 'labelXSStandard',
	labelXSEmphasize = 'labelXSEmphasize',
	captionLargeStandard = 'captionLargeStandard',
	captionLargeEmphasize = 'captionLargeEmphasize',
	captionMediumStandard = 'captionMediumStandard',
	captionMediumEmphasize = 'captionMediumEmphasize',
	captionSmallStandard = 'captionSmallStandard',
	captionSmallEmphasize = 'captionSmallEmphasize',
	numeralDisplayXL = 'numeralDisplayXL',
	numeralDisplayLarge = 'numeralDisplayLarge',
	numeralHeader2XL = 'numeralHeader2XL',
	numeralHeaderXL = 'numeralHeaderXL',
	numeralHeaderLarge = 'numeralHeaderLarge',
	numeralHeaderMedium = 'numeralHeaderMedium',
	numeralHeaderSmall = 'numeralHeaderSmall',
	numeralHeaderXS = 'numeralHeaderXS',
	numeralHeader2XS = 'numeralHeader2XS',
	numeralBodyLargeStandard = 'numeralBodyLargeStandard',
	numeralBodyLargeEmphasize = 'numeralBodyLargeEmphasize',
	numeralBodyMediumStandard = 'numeralBodyMediumStandard',
	numeralBodyMediumEmphasize = 'numeralBodyMediumEmphasize',
	numeralBodySmallStandard = 'numeralBodySmallStandard',
	numeralBodySmallEmphasize = 'numeralBodySmallEmphasize',
	numeralLabelXL = 'numeralLabelXL',
	numeralLabelLarge = 'numeralLabelLarge',
	numeralLabelMedium = 'numeralLabelMedium',
	numeralLabelSmall = 'numeralLabelSmall',
	numeralCaptionLargeStandard = 'numeralCaptionLargeStandard',
	numeralCaptionLargeEmphasize = 'numeralCaptionLargeEmphasize',
	numeralCaptionMediumStandard = 'numeralCaptionMediumStandard',
	numeralCaptionMediumEmphasize = 'numeralCaptionMediumEmphasize',
	numeralCaptionSmallStandard = 'numeralCaptionSmallStandard',
	numeralCaptionSmallEmphasize = 'numeralCaptionSmallEmphasize',
}

export enum OneStringAlignment {
	left = 'left',
	center = 'center',
	right = 'right',
}

export interface OneStringProps {
	className?: string;
	tag?: keyof HTMLElementTagNameMap;
	children: string | ReactNode;
	color?: OneStringColor;
	textStyle: OneStringTextStyle;
	alignment?: OneStringAlignment;
}
